<template>
  <div class="staff-management-settings-container">
    <div class="global-rate-of-pay-table">
      <div class="table-header">
        <div class="row">
          <div class="col-md-12">
            <HeaderColumn class="col-mileage-rate" :headerObject="arrHeaderObj[0]" :sortObject="sortObject" @CHANGE_SORT_OPTION="handleChangeSortOption"></HeaderColumn>
          </div>
        </div>
      </div>
      <div class="list-staff-settings">
<!--        <template v-for="item in listStaffSettings">-->
          <div class="ems-row">
            <div class="row">
              <div class="col-md-10">
                <div v-if="editting" class="input-currency field-value">
                  <input class="value-text" v-model="staffSettings.value" v-bind="staffSettingCurrency" @blur="handleBlurInputValue">
                </div>
                <div v-else class="mileage-rate-value field-value value-text">{{staffSettings.value || 0 | staffSettingCurrency}}</div>
              </div>
              <div class="col-md-2">
                <div class="group-action-btn">
                  <button class="ap-btn edit-btn" @click="handleEditSettingClick">
                    <div class="icon"></div>
                  </button>
                  <button class="ap-btn delete-btn">
                    <div class="icon"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
<!--        </template>-->
      </div>
    </div>
    <b-modal id="editMileageRateModal" ref="editMileageRateModal" hide-header hide-footer class="ap-modal edit-mileage-rate-modal">
      <div class="modal-mileage-rate-wrapper">
        <div class="h2-text">Edit Mileage Rate</div>
        <div class="ap-field-input-wrapper">
          <div class="body-text">Mileage Rate</div>
          <div class="ap-input-wrapper">
            <input class="input" v-model="staffSettings.value" type="number">
          </div>
          <div class="group-btn margin-top-24px">
            <button class="ap-btn secondary cancel-btn" @click="handleCancelClick">Cancel</button>
            <button class="ap-btn primary save-btn" @click="handleSaveClick">Save</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import HeaderColumn from '../commons/HeaderColumn';
  // import arrayHelper from '@/utils/array-helper';
  import storeConstants from '@/store/constants';
  import settingConstants from '@/store/modules/setting/constants';
  import { mapActions } from 'vuex';
  import {EditMileageRateModal} from '../modal';
  export default {
    name: 'c-table-rate-of-pay',
    components: {
      HeaderColumn,
      EditMileageRateModal
    },
    props: {
      staffSettings: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        arrHeaderObj: [{
          internalName: 'mileageRate',
          displayName: 'Mileage Rate'
        }],
        sortObject: {
          fieldName: '',
          reverse: false
        },
        editting: false,
        valueBackup: {}
      }
    },
    computed: {
    },
    methods: {
      handleChangeSortOption (sortObj) {
      },
      handleEditSettingClick () {
        this.valueBackup = {
          ...this.staffSettings
        };
        this.$refs.editMileageRateModal.show();
      },
      handleBlurInputValue () {
      },
      handleCancelClick () {
        this.$refs.editMileageRateModal.hide();
        this.staffSettings = {
          ...this.valueBackup
        }
      },
      handleSaveClick () {
        let body = {...this.staffSettings};
        this.updateStaffSetting(body).then(response => {
          if (response.statusCode === storeConstants.statusCodes.OK) {
            this.$toast.success('Successfully saved.', '', {
              ...this.$toastOpt.optSuccess
            });
          }
        });
      },
      ...mapActions(storeConstants.store.SETTING, {
        updateStaffSetting: `${settingConstants.ACTION_UPDATE_SETTINGS}`
      })
    },
    watch: {
    }
  };
</script>



// WEBPACK FOOTER //
// GlobalRateOfPay.vue?3f784019